import { TOGGLE_PROPERTY_ANNOTATIONS } from 'FormsUI/actions/PropertyAnnotations';
const initialState = {
  propertyHintsOn: true
};
export function propertyAnnotations(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_PROPERTY_ANNOTATIONS:
      return {
        propertyHintsOn: action.payload.newStatus
      };
    default:
      return state;
  }
}